import Loader from "./Loader";
import { options } from "./options";
import React, { FC } from "react";
import {styleSheet} from "./styles"
import injectSheet from "react-jss";

interface Props {
  classes?: any;
  isFullscreen: boolean;
}

const loading = (props: any) => {
    return (
      <div
      className={props.isFullscreen ? props.classes.fullscreenLoader : props.classes.loader}      
    >
      <Loader isVisible={true} animationData={options.loading1} />
    </div>
    );
  };

loading.defaultProps = {
    isFullscreen: false
}

export const Loading = injectSheet(styleSheet)(loading);